<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="70px">
					<el-form-item label="所属机构" prop="institutionId" v-if="institutionId<=1">
						<el-select v-model="queryParams.institutionId"  filterable placeholder="请选择机构" >
							<el-option key="1" label="平台" value="1"></el-option>
							<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态" label-width="40px">
						<el-select v-model="queryParams.state" placeholder="请选择状态">
							<el-option label="全部状态" value=""></el-option>
							<el-option label="启用" :value="1"></el-option>
							<el-option label="停用" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标签" label-width="60px">
						<el-select v-model="queryParams.tags" placeholder="请选择标签">
							<el-option label="全部" value=""></el-option>
							<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="用户名">
						<el-input v-model="queryParams.realName" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort" row-key="id" :default-expand-all="true"
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="account" label="用户名"></el-table-column>
					<el-table-column prop="tags" label="标签">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
								{{tag}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="institutionName" label="所属机构" v-if="institutionId==1"></el-table-column>
					<el-table-column prop="teamName" label="所属团队" v-else></el-table-column>
					<el-table-column prop="roleName" label="角色"></el-table-column>
					<el-table-column label="状态" width="80px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)" v-if="hashState"></el-switch>
							<span v-else>{{scope.row.state |formatState}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					</el-table-column>
					<el-table-column label="操作" :width="width" v-if="width>0">
						<template slot-scope="scope">
							<el-button size="mini" @click="handleResetPwd(scope.row)" type="primary" v-has="'btn_reset_pwd'">重置密码</el-button>
							<el-button size="mini" type="primary" v-if="roleId==3" @click="handleDeviceShare(scope.row)" v-has="'btn_share_device'">分配设备</el-button>
							<el-button size="mini" @click="handleEdit(scope.row)" type="primary" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50,100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange">
				</el-pagination>

			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="540px">
			<el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="80px" :validate-on-rule-change="false">
				<el-row>
					<el-col :span="24">
						<el-form-item label="真实姓名" prop="realName">
							<el-input v-model="addOrUpdateForm.realName" placeholder="请输入真实姓名"></el-input>
						</el-form-item>
						<el-form-item label="用户名" prop="account">
							<el-input v-if="addOrUpdateForm.id==null" v-model="addOrUpdateForm.account" placeholder="用户名为系统登录账号,设置后无法修改" autocomplete="off"></el-input>
							<el-input v-if="addOrUpdateForm.id!=null" :disabled="true" v-model="addOrUpdateForm.account" placeholder="用户名为系统登录账号,设置后无法修改"
								autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="登录密码" prop="password" v-if="addOrUpdateForm.id==null">
							<el-input type="password" v-model="addOrUpdateForm.password" placeholder="请输入密码" autocomplete="new-password"></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="password2" v-if="addOrUpdateForm.id==null">
							<el-input type="password" v-model="addOrUpdateForm.password2" placeholder="请输入确认密码" autocomplete="new-password"></el-input>
						</el-form-item>
						<el-form-item label="手机号码">
							<el-input v-model="addOrUpdateForm.mobile" placeholder="请输入手机号码"></el-input>
						</el-form-item>
						<el-form-item label="邮箱账号">
							<el-input v-model="addOrUpdateForm.email" placeholder="请输入邮箱账号"></el-input>
						</el-form-item>
						<el-form-item label="角色" prop="roleId" v-if="roleId==2">
							<el-select v-model="addOrUpdateForm.roleId" style="width: 100%;" placeholder="请选择角色">
								<el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="用户类型" v-if="roleId ==2">
							 <el-radio-group v-model="addOrUpdateForm.userType">
							    <el-radio :label="'default'">普通账户</el-radio>
							    <el-radio :label="'super'">超级账户</el-radio>
							  </el-radio-group>
						</el-form-item>
						<el-form-item label="关联机构" prop="institutionId" v-if="institutionId<=1">
							<el-select v-model="addOrUpdateForm.institutionId" style="width:100%" filterable placeholder="请选择机构" :disabled="addOrUpdateForm.id!=null">
								<el-option key="-2" label="技术" value="-2" v-if="institutionId==-2"></el-option>
								<el-option key="1" label="平台" value="1"></el-option>
								<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="关联团队" prop="teamId" v-else-if="institutionId!=-2 && roleId ==2 && addOrUpdateForm.userType !='super'">
							<el-select v-model="addOrUpdateForm.teamId" style="width: 100%;" placeholder="请选择团队" >
								<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="角色" prop="roleId" v-if="(institutionId<=1 && addOrUpdateForm.institutionId == institutionId) || roleId==3 ">
							<el-select v-model="addOrUpdateForm.roleId" style="width: 100%;" placeholder="请选择角色">
								<el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="关联标签">
							<el-input v-model="addOrUpdateForm.tag" placeholder="请输入标签,按enter键自动创建" @keyup.enter.native="handleEnter"></el-input>
							<el-tag v-for="(tag,index) in tags" :key="index" closable type="" @close="handleRemoveTag(tag)">
								{{tag}}
							</el-tag>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>

		<devicesShare ref="devicesShare" bizType='user'></devicesShare>

	</div>
</template>

<script>
	import SearchBase from '@/components/layout/base/base-search-front.vue'
	import devicesShare from '@/components/layout/devices/devicesShare';


	export default {
		extends: SearchBase,
		components: {
			devicesShare
		},
		data() {
			return {
				url: "user",
				roleList: [],
				institutionId: null,
				roleId: null,
				institutionList: [],
				teamList: [],
				tags: [

				],
				allTags: [],
				rules: {
					account: [{
						required: true,
						message: '用户名不能为空',
						trigger: 'change'
					}],
					realName: [{
						required: true,
						message: '真实姓名不能为空',
						trigger: 'change'
					}],
					password: [{
						required: true,
						message: '密码不能为空',
						trigger: 'change'
					}],
					password2: [{
						required: true,
						message: '关联机构不能为空',
						trigger: 'change'
					}],
					institutionId: [{
						required: true,
						message: '机构不能为空',
						trigger: 'change'
					}],
					teamId: [{
						required: true,
						message: '团队不能为空',
						trigger: 'change'
					}],
					roleId: [{
						required: true,
						message: '角色不能为空',
						trigger: 'change'
					}],
				}
			};
		},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						userType:'default'
					};
				}
			},
			beforeValidate() {
				if (this.institutionId > 1) {
					this.addOrUpdateForm.institutionId = this.institutionId
				}
				if (this.institutionId <= 1 && this.addOrUpdateForm.institutionId > 1) {
					this.addOrUpdateForm.roleId = 2
				} else if (this.addOrUpdateForm.institutionId > 1 && this.roleId == 2 && this.addOrUpdateForm.userType=='super') {
					this.addOrUpdateForm.teamId = 0
				}
			},
			beforeUpdate() {
				if (!this.addOrUpdateForm.id && this.addOrUpdateForm.password != this.addOrUpdateForm.password2) {
					this.$message({
						message: '两次输入密码不一致！',
						type: 'warning'
					});
					return false
				}
				this.addOrUpdateForm.tags = JSON.stringify(this.tags)
			},
			handleEnter() {
				if (this.addOrUpdateForm.tag) {
					if (this.tags.indexOf(this.addOrUpdateForm.tag) == -1) {
						this.tags.push(this.addOrUpdateForm.tag)
						this.addOrUpdateForm.tag = ""
					} else {
						this.$message({
							message: '标签' + this.addOrUpdateForm.tag + '已存在',
							type: 'warning'
						});
					}
				}
			},
			handleRemoveTag(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
			},
			beforeEdit(isEdit) {
				this.tags = []
				if (isEdit) {
					if(this.addOrUpdateForm.tags){
						this.tags = JSON.parse(this.addOrUpdateForm.tags)
					}
				}
			},
			handleDeviceShare(row) {
				this.$refs.devicesShare.show(row.id);
			},
			handleResetPwd(row) { //重置密码
				this.$confirm('此操作将重置该员工密码为000000, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let that = this;
					this.$http({
						method: 'POST',
						url: 'user/reset',
						data: {
							id: row.id,
						},
					}).then(function(res) {
						if (res.data.errorCode == '0000') {
							that.successMessage('操作成功', '重置密码成功');
							that.getList();
						}
					})
				})
			},
			getRoleList() { //获取角色列表
				let that = this;
				this.$http({
					method: 'POST',
					url: 'role/query',
					data: {
						currentPage: 1,
						pageSize: 50,
						sortOrder: "asc",
						sortProp: "id"
					},
				}).then(function(res) {
					if (that.institutionId == 1 || that.institutionId == -2) {
						var newList = []
						if (res.data.data) {
							res.data.data.forEach(item => {
								if (item.institutionId == -1) {

								} else {
									newList.push(item)
								}
							})
						}
						that.roleList = newList;
					} else {
						that.roleList = res.data.data;
					}
				})
			},
			queryInstitutionList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'institution/query',
					data: {
						currentPage: 1,
						pageSize: 100,
					},
				}).then(function(res) {
					that.institutionList = res.data.data;
				})
			},
			queryTags() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'user/queryTags',
					data: {},
				}).then(function(res) {
					that.allTags = res.data.data;
				})
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			}
		},
		mounted: function() {
			this.institutionId = sessionStorage.getItem('_institutionId');
			this.roleId = sessionStorage.getItem('_roleId');
			this.getRoleList();
			if (this.institutionId == "1" || this.institutionId == "-2") {
				this.queryInstitutionList()
			} else {
				this.queryTeamList()
			}
			this.queryTags();
		},
		created: function() {}
	}
</script>

<style scoped>
	.el-tag {
		margin: 0px 8px 5px 0px;
	}
</style>


// WEBPACK FOOTER //
// src/view/system/cmUser.vue